import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useLang } from "@/lib/lang";
import { TESTIMONIALS, fadeUp, stagger } from "./constants";

/**
 * Client testimonials carousel — reviews kept in author's original language.
 */
export default function TestimonialsSection() {
  const { t } = useLang();
  return (
    <motion.section
      id="reviews"
      className="dt-section"
      data-testid="testimonials-section"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
      variants={stagger}
    >
      <motion.p className="dt-section__eyebrow" variants={fadeUp}>{t("landing_testi_eyebrow")}</motion.p>
      <motion.h2 className="dt-section__title" variants={fadeUp}>{t("landing_testi_title")}</motion.h2>
      <motion.p className="dt-section__desc" variants={fadeUp}>{t("landing_testi_desc")}</motion.p>
      <motion.div className="dt-testimonials" variants={stagger}>
        {TESTIMONIALS.map((testi, idx) => (
          <motion.figure
            key={testi.name}
            className="dt-testimonial"
            variants={fadeUp}
            data-testid={`testimonial-${idx + 1}`}
          >
            <Quote size={28} className="dt-testimonial__quote" />
            <blockquote className="dt-testimonial__text">{testi.text}</blockquote>
            <div className="dt-testimonial__rating" aria-label={`${testi.rating} / 5`}>
              {Array.from({ length: testi.rating }).map((_, i) => (
                <Star key={i} size={14} fill="currentColor" />
              ))}
            </div>
            <figcaption className="dt-testimonial__author">
              <div className="dt-testimonial__avatar">
                {testi.name.split(" ").map((n) => n[0]).slice(0, 2).join("")}
              </div>
              <div>
                <div className="dt-testimonial__name">{testi.name}</div>
                <div className="dt-testimonial__role">{testi.role}</div>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </motion.div>
    </motion.section>
  );
}
